document.addEventListener("DOMContentLoaded", function () {
    function initSlidersForGroup(groupEl) {
      const $group = $(groupEl);
      const $main  = $group.find('.main-image-slider');
      const $thumb = $group.find('.thumbnail-slider');

      // init thumbnails first
      if ($thumb.length && !$thumb.hasClass('slick-initialized')) {
        $thumb.slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          asNavFor: $main,        // keep same style as your reference
          focusOnSelect: true,
          arrows: false,
          centerMode: false
        });
      }

      // init main after thumbs
      if ($main.length && !$main.hasClass('slick-initialized')) {
        $main.slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  asNavFor: $thumb,
  arrows: true,
  prevArrow: '<button type="button" class="slick-prev">&lt;</button>',
  nextArrow: '<button type="button" class="slick-next">&gt;</button>',
  fade: false,
  dots: true,
  swipe: false,      // disable swipe
  touchMove: false,  // disable drag
  adaptiveHeight: false
});
      } else {
        // refresh layout if already initialized
        if ($main.hasClass('slick-initialized'))  $main.slick('setPosition');
        if ($thumb.hasClass('slick-initialized')) $thumb.slick('setPosition');
      }
    }

    function showImageGroupByAlt(selectedAlt) {
      if (!selectedAlt) return;

      document.querySelectorAll('#all-product-images .image-group-by-alt').forEach(group => {
        const groupAlt = group.getAttribute('data-alt')?.trim();
        if (groupAlt === selectedAlt) {
          group.classList.remove('hide');
          initSlidersForGroup(group);
        } else {
          group.classList.add('hide');
        }
      });
    }

    // On page load: show checked color variant group (or fallback to first group)
    const checkedInput = document.querySelector('.color-var-image input[type="radio"]:checked');
    if (checkedInput) {
      const defaultImg = checkedInput.closest('li')?.querySelector('label picture img');
      const defaultAlt = defaultImg?.getAttribute('alt')?.trim();
      showImageGroupByAlt(defaultAlt);
    } else {
      const firstGroup = document.querySelector('#all-product-images .image-group-by-alt');
      if (firstGroup) {
        firstGroup.classList.remove('hide');
        initSlidersForGroup(firstGroup);
      }
    }

    // On variant swatch click (event delegation)
    document.body.addEventListener('click', function (event) {
      const clickedImg = event.target.closest('.color-var-image label picture img');
      if (clickedImg) {
        const selectedAlt = clickedImg.getAttribute('alt')?.trim();
        showImageGroupByAlt(selectedAlt);
      }
    });
  });
